import { Dialog } from 'src/design_system/molecules/dialog/Dialog'
import {
  PhoneNumberVerificationRaw,
  PhoneNumberVerificationRawProps,
} from './PhoneNumberVerificationRaw'
import { PhoneNumberInput } from 'src/graphql/generated/graphql'

type PhoneNumberVerificationDialogProps = PhoneNumberVerificationRawProps & {
  isOpen: boolean
  initialPhoneNumber?: PhoneNumberInput
  resourceType: 'FREE_CARD' | 'GIFT_CARD' | 'OTHER'
  onClose: () => void
}

export const PhoneNumberVerificationDialog = (
  props: PhoneNumberVerificationDialogProps,
) => {
  const {
    isOpen,
    allowedPhoneNumber,
    verifyPhoneNumber,
    title,
    subtitle,
    hero,
    validateButtonTitle,
    anchorButton,
    isCreateOrLogin,
    shouldDisplaySmsOptIn,
    initialPhoneNumber,
    resourceType,
    onChangeFirstAndLastName,
    onClose,
  } = props

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      padding="0px 20px 40px 20px"
      sheetBgColorOverride="#FFFFFF"
      maxWidth="590px"
    >
      <PhoneNumberVerificationRaw
        title={title}
        subtitle={subtitle}
        hero={hero}
        anchorButton={anchorButton}
        resourceType={resourceType}
        isCreateOrLogin={isCreateOrLogin}
        shouldDisplaySmsOptIn={shouldDisplaySmsOptIn}
        initialPhoneNumber={initialPhoneNumber}
        allowedPhoneNumber={allowedPhoneNumber}
        verifyPhoneNumber={verifyPhoneNumber}
        onChangeFirstAndLastName={onChangeFirstAndLastName}
        validateButtonTitle={validateButtonTitle}
      />
    </Dialog>
  )
}
